import { Box, Divider, Page, PageBlock } from 'braid-design-system';

import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { VerifyEmailAlert } from 'src/components/VerifyEmailAlert';

import { HeaderBanner } from './components/HeaderBanner';
import { PackagesPageSections } from './components/PackagesPageSections';

const PAGE_WIDTH = 'large';

const PackagesPage = () => (
  <Page footer={<SiteWideFooter />} footerPosition="belowFold">
    <Header title="Sell your business" />

    <Box display={{ mobile: 'none', tablet: 'block', desktop: 'none' }}>
      <Divider />
    </Box>

    <VerifyEmailAlert width={PAGE_WIDTH} />

    <HeaderBanner />

    <Box paddingTop="xxlarge">
      <PageBlock width={PAGE_WIDTH}>
        <PackagesPageSections />
      </PageBlock>
    </Box>
  </Page>
);

export default PackagesPage;
